import Constant from '@/const';
import axios from 'axios';

const getMedicalResume = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/inpatient/resume/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getMedicalResume;
